import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, vModelSelect as _vModelSelect, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["data-kt-menu-placement", "data-kt-menu-target"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "las la-filter text-primary fs-3" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "position-absolute top-0 start-100 translate-middle badge badge-circle badge-cyan"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "px-7 py-5" }
const _hoisted_6 = { class: "fs-5 text-dark fw-bolder d-flex justify-content-between align-items-center" }
const _hoisted_7 = ["id"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-dialog__close" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
    })
  ])
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_11 = { class: "row g-5 g-xl-8" }
const _hoisted_12 = { class: "col-xl-6" }
const _hoisted_13 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_14 = { class: "card-header border-0 pt-5" }
const _hoisted_15 = { class: "card-title align-items-start flex-column" }
const _hoisted_16 = { class: "card-label fw-bolder fs-6 mb-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-sm btn-icon bg-hover-primary text-hover-white",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#searchMessage",
    "aria-expanded": "false",
    "aria-controls": "searchMessage"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search fs-4" })
  ])
], -1)
const _hoisted_18 = { class: "card-body py-3 mh-300px scroll-y" }
const _hoisted_19 = {
  class: "mb-5 border-bottom collapse",
  id: "searchMessage"
}
const _hoisted_20 = { class: "search-form" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search fs-2" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table align-middle gs-0 gy-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-100" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-25px" })
  ])
], -1)
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "float-end"
}
const _hoisted_30 = { class: "text-end ps-0" }
const _hoisted_31 = ["onClick", "data-kt-menu-target"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h fs-2" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["id"]
const _hoisted_35 = { class: "menu-item px-3" }
const _hoisted_36 = ["data-bs-target", "onClick"]
const _hoisted_37 = { class: "menu-item px-3" }
const _hoisted_38 = ["data-bs-target", "onClick"]
const _hoisted_39 = { class: "menu-item px-3" }
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = { class: "card card-xl-stretch mb-5 mb-xl-8 border-start border-gray-300" }
const _hoisted_42 = {
  ref: "scrollRef",
  class: "card-body py-3 mh-300px",
  id: "menu-widget"
}
const _hoisted_43 = {
  class: "py-5",
  "data-kt-user-table-filter": "form"
}
const _hoisted_44 = { class: "mb-5" }
const _hoisted_45 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_46 = ["onUpdate:modelValue", "name", "onKeyup"]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = ["onUpdate:modelValue", "name"]
const _hoisted_49 = ["value"]
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = {
  key: 4,
  class: "form-check form-switch form-switch-sm form-check-custom form-check-solid"
}
const _hoisted_53 = ["onUpdate:modelValue", "name"]
const _hoisted_54 = { class: "form-check-label" }
const _hoisted_55 = {
  key: 5,
  class: "position-relative d-flex align-items-center"
}
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-2 position-absolute mx-4\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path opacity=\"0.3\" d=\"M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z\" fill=\"black\"></path><path d=\"M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z\" fill=\"black\"></path><path d=\"M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z\" fill=\"black\"></path></svg></span>", 1)
const _hoisted_57 = {
  key: 6,
  class: "position-relative d-flex align-items-center"
}
const _hoisted_58 = {
  key: 7,
  class: "position-relative d-flex align-items-center"
}
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = { class: "py-4 border-top" }
const _hoisted_61 = { class: "d-flex flex-stack px-4 mb-5" }
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = ["id"]
const _hoisted_64 = { class: "d-flex" }
const _hoisted_65 = { class: "text-end" }
const _hoisted_66 = ["disabled", "data-bs-target"]
const _hoisted_67 = ["disabled", "data-bs-target"]
const _hoisted_68 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZShowIcon = _resolveComponent("VZShowIcon")!
  const _component_VZHideIcon = _resolveComponent("VZHideIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_VZLookup = _resolveComponent("VZLookup")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vz_add_edit_modal = _resolveComponent("vz-add-edit-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$slots.actions)
      ? _renderSlot(_ctx.$slots, "actions", { key: 0 })
      : _createCommentVNode("", true),
    (_ctx.filterOptions && _ctx.filterOptions.length && !_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          ref: "triggerControl",
          type: "button",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary position-relative ms-5 mb-2 mb-sm-0",
          "data-kt-menu-trigger": "click",
          "data-kt-menu-placement": _ctx.menuPlacement,
          "data-kt-menu-permanent": "true",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickToggle && _ctx.clickToggle(...args))),
          "data-kt-menu-target": `#vz-filter-data-${_ctx.viewName}`
        }, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")) + " ", 1),
          (_ctx.activeFilter)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.activeFilter), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      "data-kt-menu": "true",
      "data-kt-menu-permanent": "true",
      class: _normalizeClass(_ctx.rowClasses),
      id: `vz-filter-data-${_ctx.viewName}`
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.t("common.savedFilter.filterOption")) + " ", 1),
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            "data-kt-menu-dismiss": "true",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyPreviousModels && _ctx.applyPreviousModels(...args)))
          }, [
            _createElementVNode("button", {
              id: `closeFilterDialogBtn${_ctx.viewName}`,
              "aria-label": "Close this dialog",
              class: "el-dialog__headerbtn",
              type: "button"
            }, _hoisted_9, 8, _hoisted_7)
          ])
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t("common.savedFilter.title")), 1)
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("form", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "searchForm",
                      autocomplete: "off",
                      placeholder: `${_ctx.t(
                      'common.savedFilter.searchPlaceHolder'
                    )}`,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event)),
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchSavedFilters && _ctx.searchSavedFilters(...args)))
                    }, null, 40, _hoisted_22), [
                      [_vModelText, _ctx.searchTerm]
                    ]),
                    _createElementVNode("span", {
                      class: "input-group-text",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchSavedFilters && _ctx.searchSavedFilters(...args)))
                    }, _hoisted_24)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("table", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedFilterList, (saved) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: saved.webId
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["cursor-pointer fw-bold d-block fs-7", {
                          'text-primary':
                            _ctx.selectedPreSavedFilter === saved.webId,
                          'text-muted': _ctx.selectedPreSavedFilter !== saved.webId,
                        }]),
                            onClick: ($event: any) => (_ctx.applyPreSavedFilter(saved))
                          }, [
                            _createTextVNode(_toDisplayString(saved.title) + " ", 1),
                            (saved.defaultIndicator)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "DEFAULT"))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_28)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.clickToggleDefaultFilter(saved.webId)),
                            class: "btn btn-active-light-primary btn-icon btn-circle btn-sm pointer trigger-class",
                            "data-kt-menu-trigger": "click",
                            "data-kt-menu-target": `#vz-saved-filters-${saved.webId}`
                          }, _hoisted_33, 8, _hoisted_31),
                          _createElementVNode("div", {
                            class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-6 w-175px py-4",
                            "data-kt-menu": "true",
                            id: `vz-saved-filters-${saved.webId}`
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("a", {
                                class: "menu-link px-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": `#vz-add-edit-modal-pre-saved-filters-${_ctx.viewName}`,
                                "data-kt-menu-dismiss": "true",
                                onClick: _withModifiers(($event: any) => (_ctx.editPreSavedFilter(saved)), ["stop"])
                              }, _toDisplayString(_ctx.t("common.edit")), 9, _hoisted_36)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("a", {
                                class: "menu-link px-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": `#vz-add-edit-modal-pre-saved-filters-${_ctx.viewName}`,
                                "data-kt-menu-dismiss": "true",
                                onClick: _withModifiers(($event: any) => (_ctx.postDefaultSavedFilter(saved)), ["stop"])
                              }, _toDisplayString(!saved.defaultIndicator
                                ? _ctx.t("common.setDefault")
                                : _ctx.t("common.removeDefault")), 9, _hoisted_38)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("a", {
                                class: "menu-link px-3",
                                "data-kt-menu-dismiss": "true",
                                disabled: _ctx.disableButton,
                                onClick: _withModifiers(($event: any) => (_ctx.deletePreSavedFilter(saved)), ["stop"])
                              }, _toDisplayString(_ctx.t("common.delete")), 9, _hoisted_40)
                            ])
                          ], 8, _hoisted_34)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showSavedFilters]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass({
          'col-xl-6': _ctx.showSavedFilters,
          'col-xl-12': !_ctx.showSavedFilters,
        })
        }, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("a", {
                      class: "cursor-pointer text-gray-800 text-hover-primary fs-5",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleShowHide && _ctx.handleShowHide(...args)), ["stop"]))
                    }, [
                      (_ctx.showSavedFilters)
                        ? (_openBlock(), _createBlock(_component_VZShowIcon, { key: 0 }))
                        : _createCommentVNode("", true),
                      (!_ctx.showSavedFilters)
                        ? (_openBlock(), _createBlock(_component_VZHideIcon, { key: 1 }))
                        : _createCommentVNode("", true),
                      (_ctx.showSavedFilters)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.t("common.hide")), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(_ctx.t("common.show")), 1)
                          ], 64))
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-5",
                    key: i
                  }, [
                    _createElementVNode("label", _mergeProps({ class: "form-label" }, item.attrs), _toDisplayString(item.label) + ":", 17),
                    (item.type === 'text')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
                          key: 0,
                          class: "form-control",
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event),
                          name: item.key,
                          onKeyup: ($event: any) => (item.onChange(_ctx.models[item.key]))
                        }, item.attrs), null, 16, _hoisted_46)), [
                          [_vModelText, _ctx.models[item.key]]
                        ])
                      : _createCommentVNode("", true),
                    (item.type === 'select' && item.options)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _withDirectives(_createElementVNode("select", _mergeProps({
                            class: "form-select",
                            "data-placeholder": "Select",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event),
                            name: item.key
                          }, item.attrs), [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, o) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: o,
                                value: option.value
                              }, _toDisplayString(option.label), 9, _hoisted_49))
                            }), 128))
                          ], 16, _hoisted_48), [
                            [_vModelSelect, _ctx.models[item.key]]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'autocomplete' && item.options)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: _ctx.models[item.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event)
                          }, item.attrs, {
                            value: _ctx.models[item.key],
                            onSelect: ($event: any) => (_ctx.handleSelect(item)),
                            onDeselect: ($event: any) => (item.onChange(_ctx.models[item.key])),
                            "close-on-select": false,
                            searchable: true,
                            "create-option": true,
                            options: item.options,
                            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                            class: "multiselect-filter"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "value", "onSelect", "onDeselect", "options"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'lookup')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createVNode(_component_VZLookup, _mergeProps(item.attrs, {
                            modelValue: _ctx.models[item.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event),
                            options: item.options,
                            value: _ctx.models[item.key]
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "value"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'checkboxes')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _withDirectives(_createElementVNode("input", _mergeProps({
                            class: "form-check-input",
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event),
                            name: item.key
                          }, item.attrs), null, 16, _hoisted_53), [
                            [_vModelCheckbox, _ctx.models[item.key]]
                          ]),
                          _createElementVNode("label", _hoisted_54, _toDisplayString(item.label), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'date')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _hoisted_56,
                          _createVNode(_component_el_date_picker, _mergeProps({
                            "value-format": "YYYY-MM-DD",
                            format: _ctx.displayDate,
                            modelValue: _ctx.models[item.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event),
                            placeholder: `${_ctx.t('validation.selectDate')}`,
                            name: item.key
                          }, item.attrs, {
                            class: "w-100",
                            onVisibleChange: _ctx.captureVisibleEvent
                          }), null, 16, ["format", "modelValue", "onUpdate:modelValue", "placeholder", "name", "onVisibleChange"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'datetimerange')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createVNode(_component_el_date_picker, _mergeProps({
                            modelValue: _ctx.models[item.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event),
                            type: "datetimerange",
                            "value-format": "YYYY-MM-DDTHH:mm:ssZ",
                            format: _ctx.displayDateTime,
                            "range-separator": "-",
                            "start-placeholder": `${_ctx.t('common.selectStartDate')}`,
                            "end-placeholder": `${_ctx.t('common.selectEndDate')}`,
                            name: item.key
                          }, item.attrs, {
                            class: "w-100",
                            onVisibleChange: _ctx.captureVisibleEvent
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "format", "start-placeholder", "end-placeholder", "name", "onVisibleChange"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'daterange')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createVNode(_component_el_date_picker, _mergeProps({
                            modelValue: _ctx.models[item.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.models[item.key]) = $event),
                            type: "daterange",
                            "value-format": "YYYY-MM-DD",
                            format: _ctx.displayDate,
                            "range-separator": "-",
                            "start-placeholder": `${_ctx.t('common.selectStartDate')}`,
                            "end-placeholder": `${_ctx.t('common.selectEndDate')}`,
                            name: item.key
                          }, item.attrs, {
                            class: "w-100",
                            onVisibleChange: _ctx.captureVisibleEvent
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "format", "start-placeholder", "end-placeholder", "name", "onVisibleChange"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 512)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("button", {
                  id: `resetFilterBtn-${_ctx.viewName}`,
                  type: "submit",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  "data-kt-menu-dismiss": "true",
                  "data-kt-user-table-filter": "reset",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetFilter()))
                }, _toDisplayString(_ctx.t("common.reset")), 9, _hoisted_63)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _withDirectives(_createElementVNode("button", {
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px me-2",
                    disabled: _ctx.selectedPreSavedFilter > 0 && _ctx.models.length > 0,
                    "data-bs-toggle": "modal",
                    "data-bs-target": `#vz-add-edit-modal-pre-saved-filters-${_ctx.viewName}`,
                    onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePreSavedFilter && _ctx.updatePreSavedFilter(...args)), ["stop"]))
                  }, _toDisplayString(_ctx.t("common.update")), 9, _hoisted_66), [
                    [_vShow, 
                    _ctx.showSavedFilters &&
                    _ctx.selectedPreSavedFilter > 0 &&
                    _ctx.savedFilterList.length > 0
                  ]
                  ]),
                  _withDirectives(_createElementVNode("button", {
                    disabled: _ctx.models.length > 0,
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px me-2",
                    "data-bs-toggle": "modal",
                    "data-bs-target": `#vz-add-edit-modal-pre-saved-filters-${_ctx.viewName}`,
                    onClick: _cache[9] || (_cache[9] = _withModifiers(
                    () => {
                      _ctx.resetSavedFilter();
                      _ctx.showAddEditModal = true;
                    }
                  , ["stop"]))
                  }, _toDisplayString(_ctx.t("common.savedFilter.savedAsNew")), 9, _hoisted_67), [
                    [_vShow, _ctx.showSavedFilters]
                  ]),
                  _createElementVNode("span", {
                    onClick: _cache[10] || (_cache[10] = () => _ctx.updateFilter(true))
                  }, [
                    _createElementVNode("button", {
                      id: `applyFilterBtn-${_ctx.viewName}`,
                      type: "submit",
                      class: "btn btn-outline btn-outline-primary btn-active-light-primary fw-bold px-6 min-w-90px",
                      "data-kt-menu-dismiss": "true",
                      "data-kt-user-table-filter": "filter"
                    }, _toDisplayString(_ctx.t("common.apply")), 9, _hoisted_68)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 10, _hoisted_4),
    _createVNode(_component_vz_add_edit_modal, {
      viewName: `pre-saved-filters-${_ctx.viewName}`,
      data: _ctx.formData,
      onOnSubmit: _ctx.postSavedFilter,
      onOnCancel: _ctx.resetSavedFilter,
      onOnClose: _ctx.resetSavedFilter,
      modelValue: _ctx.showAddEditModal,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showAddEditModal) = $event))
    }, null, 8, ["viewName", "data", "onOnSubmit", "onOnCancel", "onOnClose", "modelValue"])
  ], 64))
}